module.exports = __webpack_public_path__ + "img/addon_1.01fc82dd.png";